import React, { memo, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconButton, Tooltip, Stack, Icon } from 'investira.react.components';
import { formats, dates, validators } from 'investira.sdk';
import { BulkContextActions, DataTable } from '../../../components/organisms';
import withCenarios from '../../../hoc/withCenarios';
const StressTestSettings = memo(props => {
  const {
    ...restProps
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const xColumns = useMemo(() => {
    return [
    // {
    //   id: "ano",
    //   accessorKey: "ano",
    //   header: "Ano",
    //   enableColumnActions: false,
    //   enableSorting: false,
    //   Cell: ({ cell }) => {
    //     if (validators.isNull(cell.getValue())) {
    //       return null;
    //     }
    //     return formats.formatDate(dates.toDate(cell.getValue()));
    //   },
    // },
    {
      id: 'cenario',
      accessorKey: 'cenario',
      header: 'Cenário',
      enableColumnActions: false,
      enableSorting: false,
      muiTableHeadCellProps: {
        sx: {
          //width: "100% !important",
          whiteSpace: 'nowrap'
        }
      },
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: 'nowrap'
        }
      },
      Cell: ({
        cell
      }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return cell.getValue();
      }
    }, {
      id: 'descricao',
      accessorKey: 'descricao',
      header: 'Descrição',
      enableColumnActions: false,
      enableSorting: false,
      muiTableHeadCellProps: {
        sx: {
          width: '100% !important'
        }
      },
      muiTableBodyCellProps: {
        sx: {
          fontSize: '0.75rem'
        }
      },
      Cell: ({
        cell
      }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return cell.getValue();
      }
    }, {
      id: 'periodo_inicio',
      accessorKey: 'inicio',
      header: 'Início',
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({
        cell
      }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      }
    }, {
      id: 'periodo_fim',
      accessorKey: 'fim',
      header: 'Fim',
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({
        cell
      }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return formats.formatDate(dates.toDate(cell.getValue()));
      }
    }];
  }, []);
  const xProps = {
    columns: xColumns,
    data: props.cenarios,
    readData: props.readCenarios,
    isLoading: props.isLoading,
    initialState: {
      pagination: props.pagination,
      columnVisibility: {
        carteira: false
      },
      columnSizing: {
        // Define larguras fixas para as colunas de seleção e ações
        'mrt-row-select': 50,
        // Largura fixa para a coluna de seleção
        'mrt-row-actions': 80 // Largura fixa para a coluna de ações
      },
      density: 'comfortable'
    },
    manualFiltering: true,
    manualSorting: true,
    manualPagination: true,
    getRowId: row => row.log_id,
    state: {
      isLoading: props.isLoading,
      pagination: props.pagination,
      showProgressBars: props.isRefetching,
      columnFilters: props.columnFilters,
      sorting: props.sorting,
      rowSelection: props.rowSelection
    },
    rowCount: props.rowCount,
    onColumnFiltersChange: props.setColumnFilters,
    onSortingChange: props.setSorting,
    onPaginationChange: props.setPagination,
    onRowSelectionChange: props.setRowSelection,
    onGlobalFilterChange: props.setGlobalFilter,
    //onBulkDeleteClick: props.bulkDeleteLogs,
    enableRowSelection: row => !row.original.padrao,
    renderTopToolbarCustomActions: ({
      table
    }) => {
      const selectedRows = table.getSelectedRowModel().rows;
      const isSomeRowSelected = selectedRows.length > 0;
      return <BulkContextActions onDeleteClick={() => {
        props.bulkDeleteCenarios(selectedRows);
      }} disabled={props.isLoading || props.isRefetching || !isSomeRowSelected} />;
    },
    muiTableContainerProps: {
      sx: {
        maxWidth: '100%' // Garante que a tabela ocupe 100% do espaço disponível
      }
    },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 80 // largura em pixels para a coluna de ações
      },
      'mrt-row-select': {
        size: 50 // largura em pixels para a coluna de seleção
      }
    },
    renderRowActions: ({
      row
    }) => {
      const {
        favorito,
        padrao,
        cenario_id
      } = row.original;
      return <Stack direction="row" spacing={1}>
          <Tooltip title="Favoritar">
            <IconButton color="primary" onClick={() => {
            props.favCenario && props.favCenario({
              cenario_id,
              favorito: Boolean(favorito) ? 0 : 1
            });
          }}>
              <Icon iconName={Boolean(favorito) ? 'star5_filled' : 'star5'} size={21} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Editar">
            <span>
              <IconButton color="primary" disabled={padrao} onClick={() => navigate(`${location.pathname}/edit`, {
              state: row.original
            })}>
                <Icon iconName="edit" size={18} />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>;
    },
    ...restProps
  };
  return <DataTable {...xProps} />;
});
StressTestSettings.displayName = 'StressTestSettings';
export default withCenarios(StressTestSettings);
